// Presentation-only: keep generated content intact in storage; omit emoji glyphs in UI/PDF.
export const displayText = (value) => String(value ?? "")
  .replace(/(?:\p{Extended_Pictographic}|\p{Regional_Indicator}|\p{Emoji_Modifier})\uFE0F?\u200D?/gu, "")
  .replace(/[\u200D\uFE0F\u20E3]/g, "");
